import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class ProgressBar extends Field {
  static attributesForModel() {
    return ['progress'];
  }

  get title() {
    return 'Progress bar';
  }

  exampleContents(): FieldContentsData {
    return { progress: 35 };
  }

  contentsForRecord(record): FieldContentsData {
    if (typeof record.progress === 'number') {
      return { progress: record.progress };
    }

    return {};
  }
}
